import { getAxiosInstance } from "../../../../api";

export const PrintCertficate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/printing-report/create-print`, body);
    return res;
  } catch (error) {
    // error.response is undefined on network failures — don't throw here.
    return error?.response?.data;
  }
};

export const PreviewPrintCertficate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/printing-report/preview-print`, body);
    return res;
  } catch (error) {
    // error.response is undefined on network failures — don't throw here.
    return error?.response?.data;
  }
};
